export default __webpack_public_path__ + "static/media/UDYAM AADHAR INSHA BANGALES PVT LTD_page-0005.0f982178.jpg";